export default {
  ALL: 'Hepsi',
  PENDING_DEMAND: 'Talep Toplanıyor',
  PENDING_PLANNING: 'Planlama Bekleniyor',
  PENDING_OPTIMIZATION_RESULT: 'Planlama Bekleniyor',
  PENDING_RECURRING_OPTIMIZATION: 'Planlama Bekleniyor',
  PENDING_SECOND_CUTOFF: 'İkinci Planlama Bekleniyor',
  PLANNING_END: 'Planlama Bitiş',
  DEMAND_END: 'Talep Bitiş',
  ACTIVE: 'Aktif',
  INCOMPLETE: 'Tanımlama Eksik',
  PENDING_ASSIGNMENT: 'Atama Bekleniyor',
  archive: 'Arşiv',
  locations: {
    CAMPUS: 'Ofis',
    POI: 'Poi',
    PERSONNEL_SHUTTLE_STOP: 'Duraklar',
    PERSONNEL_HOME_ADDRESS: 'Personel Ev Adresleri',
    PERSONNEL_WORK_LOCATION: 'Personel İş Konumları',
  },
  header: 'Çalışma Grupları',
  createWorkgroup: 'Yeni Rota Grubu',
  timeOfArrival: 'Varış Saati',
  departureTime: 'Çıkış Saati',
  arrivalTime: 'Varış Saati',
  readyToDeparture: 'Çıkışa Hazır',
  period: 'Periyot',
  periodicallyUpdatedGroup: 'Periyodik Güncellenen Grup',
  periodicallyUpdatedGroupInfo:
    'Periyodik güncellenen gruplarda her periyot için talep toplanır ve katılımcılara göre rotalar oluşturulur.',
  selectPeriod: 'Periyot seçiniz',
  roundTrip: 'Gidiş - Geliş',
  oneWay: 'Tek Yön',
  doubleDirection: 'Çift Yön',
  fromWhere: 'Nereden',
  toWhere: 'Nereye',
  openSelectMenu: 'Bu menüyü aç',
  groupName: 'Grup adı',
  enterDescription: 'Bir açıklama girebilirsiniz',
  giveNameToGroup: 'Gruba bir isim verin',
  selectLocation: 'Bir konum seçin',
  selectDeparturePoint: 'İlk yolculuk için çıkış noktası seçin',
  responsibleCampus: 'Sorumlu kampüs',
  openToDemand: 'Talep almaya açık.',
  riderQuota: 'Kontenjanı sınırla.',
  wheelchairQuota: 'Wheelchair kontenjanı sınırla.',
  wheelchairQuotaRequired: 'Wheelchair kota limiti etkinleştirildiğinde Wheelchair kota değeri gereklidir.',
  departmentRequest: 'Talep yapabilen bölümler',
  reportPlanningEnd: 'Rapor Planlama Bitiş Tarihi',
  startOfBookbuilding: 'Talep Toplama Başlangıç',
  endOfBookbuilding: 'Talep Toplama Bitişi',
  waitlistOptinDeadline: 'Bekleme listesi talep bitiş süresi',
  definition: 'Tanım',
  location: 'Konumlar',
  timing: 'Zamanlama',
  operationTimes: 'İşlem Zamanları',
  changeRouteOrStop: 'Rota veya Durak Değiştir',
  removeFromGroup: 'Gruptan Çıkar',
  routePlanning: 'Rota planlamanin bir bitiş tarihi var',
  picnic: 'Piknik',
  overwork: 'Fazla Mesai',
  saturdayShift: 'Cumartesi Vardiya',
  customAddress: 'Özel Adres',
  personnelLocations: 'Personel Konumları',
  PERSONNEL_SHUTTLE_STOP: 'Duraklar',
  PERSONNEL_HOME_ADDRESS: 'Personel Ev Adresleri',
  PERSONNEL_WORK_LOCATION: 'Personel İş Konumları',
  createRecurringGroups: 'Periyodik grupları başlangıç zamanından',
  beforeStart: 'önce yarat.',
  makeDefault: 'Varsayılan Yap',
  default: 'Varsayılan',
  searchGroup: 'Grup Ara',
  selectedPerson: 'kişi seçildi',
  archiveSearchGroup: 'Arşiv grupları ara...',
  deleteSelected: 'Seçilenleri Sil',
  sortBy: 'Sırala',
  sortByEndDate: 'Bitiş tarihine göre sırala',
  sortByStartDate: 'Başlangıç tarihine göre sırala',
  sortByEmployeesCount: 'Personel sayısına göre sırala',
  indefinite: 'Süresiz',
  showMore: 'Daha Fazla Göster',
  campus: 'Yerleşke',
  selectEndDate: 'Bitiş Tarihi Seç',
  hoursBeforeTrip: 'ilk yolculuktan {hours} saat önce',
  hoursBeforeFirstTrip: 'Planlama ilk yolculuktan {hours} saat önce biter',
  changeStatus: 'Statü Değiştir',
  statusChanged: 'Statü {0} olarak değiştirildi.',
  invalidDepartureTime: 'Çıkış Saati Hatalı',
  invalidArrivalTime: 'Varış Saati Hatalı',
  addNewCustomAddress: 'Yeni Özel Adres Ekle',
  descriptor: 'Tanımlayan',
  createdBy: 'Tanımlayan',
  makeDefaultRouteGroup: 'Yeni eklenen personel için varsayılan rota grubu yap.',
  paidRoutes: 'Ücretli Rotalar',
  farePerTrip: 'Sefer Başına Ücret',
  organizationBoardingFare: 'Organizasyon Yolcu Ücreti',
  guestBoardingFare: 'Misafir Yolcu Ücreti',
  boardingFare: 'Yolcu Ücreti',
  monthlyPassApplied: 'Aylık ücretsiz abonelik',
  riderPercent: 'Yolcu',
  organizationPercent: 'Organizasyon',
  feeFieldsRequired: 'Bu alanlar boş bırakılamaz: {fields}',
  percentValuesMustBeBetween0And100: 'Yolcu ve organizasyon yüzdeleri 0-100 arasında olmalıdır.',
  totalPercentCannotExceed100: "Yolcu ve organizasyon yüzdelerinin toplamı 100%'ü geçemez",
  personnelLabeledVanpoolOnly: 'Sadece vanpool etiketli personel',
  optimization: 'Optimizasyon',
  automation: 'Otomasyon',
  vehicleAssignment: 'Araç Atama',
  assignDriverVehicleAutomatically: 'Sürücü ve aracı sistem tarafından otomatik ata',
  assignManually: 'Manuel ata',
  assignmentsFor: '{regionName} için atamalar',
  addDriverAndVehicle: '+ Sürücü ve Araç Ekle',
  activation: 'Aktivasyon',
  initiateAutomation: 'Otomasyonu Başlat',
  automationConfirm: {
    initiateTitle: 'Otomasyon Başlatılsın mı?',
    initiateMessage:
      'Otomasyon akışı, bu rota grubu için güncel yolcu listesi kullanılarak çalıştırılacaktır. Rotalar oluşturulacak ve otomasyon ayarlarınıza bağlı olarak sürücü ve araç atamaları yapılıp rotalar otomatik olarak aktive edilecektir. Devam etmek istiyor musunuz?',
    runButton: 'Optimizasyonu Çalıştır',
    rerunTitle: 'Otomasyon Yeniden Çalıştırılsın mı?',
    rerunMessage:
      'Bu rota grubu için rotalar daha önce oluşturulmuştur. Devam ederseniz:<br><br>(1) Mevcut rotaların başlamamış tüm seferleri iptal edilecektir.<br>(2) Rotalar, güncel yolcu listesine göre yeniden oluşturulacaktır.<br>(3) Mevcut rotalar üzerinde yapılmış tüm manuel değişiklikler kaybolacaktır.<br>(4) Devam eden veya tamamlanmış seferler etkilenmeyecektir; yeni rotalar bir sonraki seferden itibaren geçerli olacaktır.<br><br>Devam etmek istiyor musunuz?',
    rerunButton: 'Yeniden Çalıştır',
  },
  deleteGroupInstanceConfirm: 'Bu grubu silmek istediğinize emin misiniz?',
  startsFromtheDepot: 'Depodan Başla',
  startingDepot: 'Başlangıç Deposu',
  selectDepot: 'Depo Seçin',
  endingDepot: 'Bitiş Depo',
  endsintheDepot: 'Depoda bitir',
  headwayBasedOtpTracking: 'Sefer aralığına dayalı Performans takibi',
  definedRegion: 'Tanımlanmış bölge(ler)',
  coverageArea: 'Kapsama Alanı',
  noRestrictions: 'Kısıtlama yok',
  addCampus: 'Kampüs Ekle',
  multiCampus: 'Birden çok yerleşke',
  selectRegion: 'Region Seçin',
  selectADeparturePoint: 'Bir kalkış noktası seçin',
  enterThereadyToDepartureDepartureTimes: 'İstenilen kalkışa hazır ve ilk kampüsten ayrılış saatlerini girin',
  enterArrivalTimeToLastDestination: 'Son varış noktasına istenilen varış zamanını girin',
  serviceTimeForEachStop: 'Her durak için hizmet süresi',
  maxTripDuration: 'Maksimum sefer süresi',
  maxTripDurationHint:
    'Optimizasyonda bir aracın seferde geçirebileceği en uzun süre. Boş bırakılırsa 180 dakika kullanılır.',
  calculate: 'Hesapla',
  vehicleTrackingStart: 'Araç başlangıç zamanı',
  dynamic: 'Dinamik',
  regular: 'Düzenli',
  fixed: 'Sabit',
  DYNAMİC: 'Dinamik',
  REGULAR: 'Düzenli',
  FIXED: 'Sabit',
  readyForDepartureMustEarlierDepartureTime: 'Kalkışa hazır saati kalkış saatinden erken olmalıdır.',
  acceptsReservations: 'Rezervasyona Açık',
  waitlistEnabled: 'İlk talep toplamadan sonra bekleme listesini aktifleştir',
  demandEndMustBeGreaterThanSecondCutOff:
    'İlk talep toplama süresi, bekleme listesi talep bitiş süresinden büyük olmalıdır.',
  waitlistSecondCutOffRequired: 'Bekleme listesi etkinleştirildiğinde ilk talep toplama süresi zorunludur.',
  demandEndRequired: 'Bekleme listesi talep bitiş süresi girildiğinde ilk talep toplama süresi de girilmelidir.',
  noReservations: 'Rezervasyona Kapalı',
  ring: 'Ring',
  schedule: 'Planlanmış',
  startingEndingPoint: 'Başlangıç/Bitiş Noktası',
  stops: 'Duraklar',
  workdays: 'Hafta içi 5 gün',
  singleTrip: 'Tek seferlik seyahat',
  multipleTrips: 'Çoklu Seyahatler',
  periodical: 'Periyodik',
  atSpecificHours: 'Belirli Saatlerde',
  departureTimeFromFirstPoint: 'İlk noktadan itibaren istediğiniz kalkış saatini girin',
  tripsOnEver: 'Trips on ever',
  numberOfTrips: 'Seyahat Sayısı',
  min: 'dakika(lar)',
  hour: 'saat(ler)',
  totalDurationhours: 'Seferlerin toplam süresi 24 saati aşıyor.',
  addStop: 'Durak Ekle',
  deleteThisRouteGroup:
    'Bu rota grubu silindiğinde, henüz başlamamış olan tüm seferler silinecektir. Bu işlem geri alınamaz. Emin misiniz?',
  updateEndDateWarning:
    'Yeni bitiş tarihinden sonra henüz başlamamış olan tüm seferler kaldırılacaktır. Bitiş tarihini uzatırsanız, söz konusu tarihlere ait seferler yeniden oluşturulacaktır.',
  acceptReservations: 'Rezervasyonları Kabul Et',
  theSameDay: 'Aynı Gün',
  daysBeforeTripDate: 'Seyahat tarihinden önceki gün(ler)',
  singleSelectedMulticampusMessage:
    '‘Birden çok yerleşke’ seçili olduğu halde tek yerleşke seçtiniz. Başka yerleşke eklemek istiyor musunuz?',
  calculateAccordingly: 'Hepsi için buna göre hesapla',
  departureTimeCampusName: 'Kalkış Saati <b>{0}',
  reservationsCanBeMadeUntilCutOffTime: 'Rezervasyonlar belirlenen son tarihe kadar yapılabilmektedir.',
  closeFilters: 'Filtreleri Kapat',
  type: 'Rota türü',
  creator: 'Oluşturan',
  reservations: 'Rezervasyonlar',
  required: 'Zorunlu',
  notRequired: 'Zorunlu Değil',
  campusCommuteOptions:
    'Kampüs saatlerini mobil uygulamada kayıt sırasında işe geliş-gidiş saati opsiyonlarında göster.',
  validationErrors: 'Doğrulama Hataları',
  startDateRequired: 'Başlangıç tarihi gereklidir',
  departureTimeError: 'Kalkış saatinde hatalar var',
  arrivalTimeError: 'Varış saatinde hatalar var',
  endDateRequired: 'Bitiş tarihi seçeneği seçildiğinde bitiş tarihi gereklidir',
  periodRequired: 'Periyodik güncellenen gruplar için periyot seçimi gereklidir',
  readyTimeMustBeBeforeDeparture: 'Kalkışa hazır saati, kalkış saatinden önce olmalıdır',
  allDepartureTimesRequired: 'Her kampüs konumu için tüm kalkış saatleri doldurulmalıdır',
  allTimesRequiredForRoundTrip: 'Gidiş-dönüş için tüm kalkış saatleri ve dönüş varış saati gereklidir',
  allTimesRequiredForRoundTripMulti:
    'Birden çok kampüslü gidiş-dönüş için tüm kalkış saatleri ve dönüş varış saatleri gereklidir',
  arrivalTimeRequired: 'Varış saati gereklidir',
  returnTimesRequired: 'Gidiş-dönüş için dönüş kalkış ve hazır saatleri gereklidir',
  allArrivalTimesRequired: 'Her kampüs konumu için tüm varış saatleri doldurulmalıdır',
  allReturnTimesRequired: 'Birden çok kampüslü gidiş-dönüş için tüm dönüş saatleri doldurulmalıdır',
  // New cutoff time translations
  unitHours: 'saat',
  beforeTripAt: 'önce, saat',
  until: 'Saat',
  startAt: 'Saat',
  value: 'Değer',
  daysBeforeTrip: 'sefer gününden önce gün',
  startTimeRequired: 'Saat gereklidir',
  startDaysRequired: 'Gün değeri gereklidir',
  endTimeRequired: 'Saat gereklidir',
  endDaysRequired: 'Gün değeri gereklidir',
  waitlistTimeRequired: 'Saat gereklidir',
  waitlistDaysRequired: 'Bekleme listesi gün değeri gereklidir',
  valueCannotBeNegative: 'Değer negatif olamaz',
  validationWaitlistAfterEnd: 'Bekleme listesi talep bitiş süresi, talep toplama bitiş süresinden önce olamaz.',
  validationEndBeforeStart: 'Talep toplama bitiş süresi, talep toplama başlangıç süresinden önce olamaz.',
  validationStartAfterReadyTime: 'Talep toplama başlangıç süresi, sefer hazır olma saatinden sonra olamaz.',
  validationEndAfterReadyTime: 'Talep toplama bitiş süresi, sefer hazır olma saatinden sonra olamaz.',
  validationSameDayRequired:
    'Talep toplama bitiş süresi aynı gün seçiliyse, bekleme listesi talep bitiş süresi de aynı gün seçili olmalıdır.',
  quotaRequired: 'Kota limiti etkinleştirildiğinde kota değeri gereklidir.',
  person: 'kişi',
};
